// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM8.5 17H10.5V7H8.5V17ZM13.5 17H15.5V7H13.5V17Z"}}]};

const PauseCircleStrokeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pause-circle-stroke-filled',
    ref,
    icon: element,
  },
));

PauseCircleStrokeFilledIcon.displayName = 'PauseCircleStrokeFilledIcon';

export default PauseCircleStrokeFilledIcon;
